import state from './module-invoice-check-history-state';
import mutations from './module-invoice-check-history-mutations';
import actions from './module-invoice-check-history-actions';
import getters from './module-invoice-check-history-getters';

/**
 * store of invoice checking update
 */
export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
